import React, { useState, useEffect } from 'react';

export default function ConfigApi() {
    const [apiKey, setApiKey] = useState('');
    const [saved, setSaved] = useState(false);

    useEffect(() => {
        const storedKey = localStorage.getItem('GEMINI_API_KEY');
        if (storedKey) {
            setApiKey(storedKey);
        }
    }, []);

    const handleSave = () => {
        localStorage.setItem('GEMINI_API_KEY', apiKey);
        setSaved(true);
        setTimeout(() => setSaved(false), 3000);
    };

    return (
        <div className="max-w-2xl">
            <h2 className="text-xl font-bold mb-4 text-gray-800">Configuración de API (Inteligencia Artificial)</h2>
            <p className="text-gray-600 mb-6 text-sm">
                Configura aquí tu clave de API de Google Gemini (AI Studio). Esta clave se utiliza para alimentar 
                las funcionalidades de extracción inteligente de datos (como la lectura avanzada de Excels).
            </p>

            <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    Google Gemini API Key
                </label>
                <input
                    type="password"
                    value={apiKey}
                    onChange={(e) => setApiKey(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500"
                    placeholder="AIzaSy..."
                />
                <p className="text-xs text-gray-500 mt-2">
                    La clave se guardará de forma segura en el almacenamiento local de tu navegador.
                </p>
            </div>

            <button
                onClick={handleSave}
                className="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 font-medium transition-colors"
            >
                Guardar Configuración
            </button>

            {saved && (
                <div className="mt-4 p-3 bg-green-50 text-green-700 border border-green-200 rounded-lg text-sm">
                    Clave guardada exitosamente.
                </div>
            )}
        </div>
    );
}
